import React, { useEffect, useState } from "react";
import { memberApi } from "@/lib/memberAuth";
import { toast } from "sonner";
import { Newspaper } from "@phosphor-icons/react";

export default function MemberNews() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    memberApi.get("/portal/news")
      .then(({ data }) => setStories(data.stories || []))
      .catch(() => toast.error("Could not load news"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="portal-news">
      <header className="mb-6">
        <div className="overline mb-1">Portal</div>
        <h1 className="font-display text-3xl font-bold text-navy tracking-tight flex items-center gap-2">
          <Newspaper size={24} weight="duotone" className="text-ember" /> Members News
        </h1>
        <p className="text-sm text-navy/70 mt-2 max-w-2xl">
          Real corridor stories from EPAS members — shipments closed, terminals opened, partnerships in motion.
          One story per move, no volume brags.
        </p>
      </header>

      {loading ? (
        <div className="border border-black/10 bg-white p-8 text-center text-navy/50 text-sm">Loading…</div>
      ) : stories.length === 0 ? (
        <div className="border border-black/10 bg-white p-8 text-center text-navy/50 text-sm">
          No stories published yet. The first goes up as soon as the first joint shipment closes.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {stories.map((s) => (
            <article key={s.id} className="border border-black/10 bg-white flex flex-col overflow-hidden" data-testid={`news-story-${s.id}`}>
              {s.image_url && (
                <img src={s.image_url} alt="" className="w-full aspect-[3/2] object-cover" loading="lazy" />
              )}
              <div className="p-5 flex flex-col flex-1">
                {s.member_company && (
                  <div className="overline text-navy/60 mb-2">{s.member_company}</div>
                )}
                <h2 className="font-display font-bold text-navy text-lg leading-snug">{s.title}</h2>
                <p className="text-sm text-navy/70 mt-2 flex-1 whitespace-pre-wrap">{s.summary}</p>
                <div className="text-[10px] uppercase tracking-widest text-navy/40 mt-4">
                  {s.published_at ? new Date(s.published_at).toLocaleDateString() : ""}
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
